import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';

import { CookieConsentService } from '../../../core/services/cookie-consent.service';
import { TranslateService } from '../../../core/services/translate.service';
import {
  CookiePreferenceKey,
  CookiePreferences,
} from '../../interfaces/cookie-preferences.interface';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.html',
  styleUrl: './cookie-consent.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieConsent {
  private readonly consent = inject(CookieConsentService);
  protected readonly translate = inject(TranslateService);

  protected readonly dialog = this.consent.dialog;
  protected readonly preferences = this.consent.preferences;
  protected readonly hasSavedPreferences = this.consent.hasSavedPreferences;
  protected readonly draft = signal<CookiePreferences>(this.preferences());

  protected openPolicy(): void {
    this.consent.openPolicy();
  }

  protected openSettings(): void {
    this.draft.set({ ...this.preferences() });
    this.consent.openSettings();
  }

  protected closeDialog(): void {
    this.consent.closeDialog();
  }

  protected updatePreference(preference: CookiePreferenceKey, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.draft.update((value) => ({ ...value, [preference]: checked }));
  }

  protected confirmChoices(): void {
    this.consent.save(this.draft());
    this.closeDialog();
  }

  protected acceptAll(): void {
    this.consent.acceptAll();
    this.closeDialog();
  }
}
